import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Order, ParkingOrder } from '../../../models/orderModel';
import { OrderShuttle } from '../../../models/ShuttleBookingModel';
import { CheckoutService } from '../../../services/checkout.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ReceiptComponent implements OnInit {
  orderId: string;
  configType: string;
  order: Order;
  parkingOrder: ParkingOrder;
  shuttleOrders: OrderShuttle[];

  constructor(
    private activatedRoute: ActivatedRoute,
    public checkoutService: CheckoutService,
    public router: Router
  ) { }

  ngOnInit(): void {
    sessionStorage.removeItem('isFromCustomerHome');
    sessionStorage.removeItem('selectedParkingFromSearch');
    this.getOrderId();
  }

  getOrderId() {
    this.activatedRoute.params.subscribe(params => {
      this.orderId = params['orderId'];
      this.configType = params['configType'];
      this.getOrderParkings();
      this.getOrderShuttles();
      this.getOrder();
    });
  }

  getOrder() {
    this.checkoutService.getOrder(this.orderId).subscribe(order => {
      this.order = order;
    });
  }

  getOrderParkings() {
    this.checkoutService.orderParkingsOrder(this.orderId).subscribe(parkingOrder => {
      this.parkingOrder = parkingOrder;
    });
  }

  getOrderShuttles() {
    this.checkoutService.orderShuttlesOrder(this.orderId).subscribe(shuttleOrders => {
      this.shuttleOrders = shuttleOrders;
    });
  }

  goToWhenDone(): void {

    if (this.order.organizationId == null) {
      this.router.navigate(['/flygets/flygets-start']);
    }

    if (this.order.organizationId.toUpperCase() == '39218780-069A-4C6B-9925-22365A075C15' ||
      this.order.organizationId.toUpperCase() == '417596F5-8FE5-4FA7-84DC-0AF0ACE72CF1' ||
      this.order.organizationId.toUpperCase() == 'A09630B0-C850-483F-9EAC-F5DB80D28893' ||
      this.order.organizationId.toUpperCase() == '5BF79F25-27BF-4B5B-AF83-B4A0233DAB70' ||
      this.order.organizationId.toUpperCase() == 'D6B9D8C6-8FB5-41A5-AC2E-B3FC007A8251' ||
      this.order.organizationId.toUpperCase() == 'AC589E4E-5E38-4555-9BBF-AD4B1E2AD0DA') {

      this.router.navigate(['/booking-service/' + this.order.organizationId.toUpperCase()]);
    }
    else {
      this.router.navigate(['/flygets/flygets-start']);
    }
  }
}
